export const DOCTORS_GET_REQUESTED = 'DOCTORS_GET_REQUESTED';
export const DOCTORS_GET_SUCCEED = 'DOCTORS_GET_SUCCEED';
export const DOCTORS_GET_FAILED = 'DOCTORS_GET_FAILED';

export const FELLOW_DOCTORS_GET_REQUESTED = 'FELLOW_DOCTORS_GET_REQUESTED';
export const FELLOW_DOCTORS_GET_SUCCEED = 'FELLOW_DOCTORS_GET_SUCCEED';
export const FELLOW_DOCTORS_GET_FAILED = 'FELLOW_DOCTORS_GET_FAILED';

export const DOCTORS_RESET_STATE = 'DOCTORS_RESET_STATE';

export const DOCTOR_GET_PROFILE_REQUESTED = 'DOCTOR_GET_PROFILE_REQUESTED';
export const DOCTOR_GET_PROFILE_SUCCEED = 'DOCTOR_GET_PROFILE_SUCCEED';
export const DOCTOR_GET_PROFILE_FAILED = 'DOCTOR_GET_PROFILE_FAILED';

export const DOCTOR_UPDATE_PROFILE_REQUESTED = 'DOCTOR_UPDATE_PROFILE_REQUESTED';
export const DOCTOR_UPDATE_PROFILE_SUCCEED = 'DOCTOR_UPDATE_PROFILE_SUCCEED';
export const DOCTOR_UPDATE_PROFILE_FAILED = 'DOCTOR_UPDATE_PROFILE_FAILED';

export const DOCTOR_UPDATE_INFO_REQUESTED = 'DOCTOR_UPDATE_INFO_REQUESTED';
export const DOCTOR_UPDATE_INFO_SUCCEED = 'DOCTOR_UPDATE_INFO_SUCCEED';
export const DOCTOR_UPDATE_INFO_FAILED = 'DOCTOR_UPDATE_INFO_FAILED';

export const DOCTOR_TITLE_GET_REQUESTED = 'DOCTOR_TITLE_GET_REQUESTED';
export const DOCTOR_TITLE_GET_SUCCEED = 'DOCTOR_TITLE_GET_SUCCEED';
export const DOCTOR_TITLE_GET_FAILED = 'DOCTOR_TITLE_GET_FAILED';

export const DOCTOR_UPDATE_COLLEGES_REQUESTED = 'DOCTOR_UPDATE_COLLEGES_REQUESTED';
export const DOCTOR_UPDATE_COLLEGES_SUCCEED = 'DOCTOR_UPDATE_COLLEGES_SUCCEED';
export const DOCTOR_UPDATE_COLLEGES_FAILED = 'DOCTOR_UPDATE_COLLEGES_FAILED';

export const DOCTOR_UPDATE_COLLEGE_REQUESTED = 'DOCTOR_UPDATE_COLLEGE_REQUESTED';
export const DOCTOR_UPDATE_COLLEGE_SUCCEED = 'DOCTOR_UPDATE_COLLEGE_SUCCEED';
export const DOCTOR_UPDATE_COLLEGE_FAILED = 'DOCTOR_UPDATE_COLLEGE_FAILED';

export const DOCTOR_ADD_COLLEGE_REQUESTED = 'DOCTOR_ADD_COLLEGE_REQUESTED';
export const DOCTOR_ADD_COLLEGE_SUCCEED = 'DOCTOR_ADD_COLLEGE_SUCCEED';
export const DOCTOR_ADD_COLLEGE_FAILED = 'DOCTOR_ADD_COLLEGE_FAILED';

export const DOCTOR_DELETE_COLLEGE_REQUESTED = 'DOCTOR_DELETE_COLLEGE_REQUESTED';
export const DOCTOR_DELETE_COLLEGE_SUCCEED = 'DOCTOR_DELETE_COLLEGE_SUCCEED';
export const DOCTOR_DELETE_COLLEGE_FAILED = 'DOCTOR_DELETE_COLLEGE_FAILED';

export const DOCTOR_UPDATE_QUALIFICATIONS_REQUESTED = 'DOCTOR_UPDATE_QUALIFICATIONS_REQUESTED';
export const DOCTOR_UPDATE_QUALIFICATIONS_SUCCEED = 'DOCTOR_UPDATE_QUALIFICATIONS_SUCCEED';
export const DOCTOR_UPDATE_QUALIFICATIONS_FAILED = 'DOCTOR_UPDATE_QUALIFICATIONS_FAILED';

export const DOCTOR_UPDATE_QUALIFICATION_REQUESTED = 'DOCTOR_UPDATE_QUALIFICATION_REQUESTED';
export const DOCTOR_UPDATE_QUALIFICATION_SUCCEED = 'DOCTOR_UPDATE_QUALIFICATION_SUCCEED';
export const DOCTOR_UPDATE_QUALIFICATION_FAILED = 'DOCTOR_UPDATE_QUALIFICATION_FAILED';

export const DOCTOR_ADD_QUALIFICATION_REQUESTED = 'DOCTOR_ADD_QUALIFICATION_REQUESTED';
export const DOCTOR_ADD_QUALIFICATION_SUCCEED = 'DOCTOR_ADD_QUALIFICATION_SUCCEED';
export const DOCTOR_ADD_QUALIFICATION_FAILED = 'DOCTOR_ADD_QUALIFICATION_FAILED';

export const DOCTOR_DELETE_QUALIFICATION_REQUESTED = 'DOCTOR_DELETE_QUALIFICATION_REQUESTED';
export const DOCTOR_DELETE_QUALIFICATION_SUCCEED = 'DOCTOR_DELETE_QUALIFICATION_SUCCEED';
export const DOCTOR_DELETE_QUALIFICATION_FAILED = 'DOCTOR_DELETE_QUALIFICATION_FAILED';

export const DOCTORS_GET_SPECIALTIES_REQUESTED = 'DOCTORS_GET_SPECIALTIES_REQUESTED';
export const DOCTORS_GET_SPECIALTIES_SUCCEED = 'DOCTORS_GET_SPECIALTIES_SUCCEED';
export const DOCTORS_GET_SPECIALTIES_FAILED = 'DOCTORS_GET_SPECIALTIES_FAILED';

export const DOCTOR_CURRENCY_REQUESTED = 'DOCTOR_CURRENCY_REQUESTED';
export const DOCTOR_CURRENCY_SUCCEED = 'DOCTOR_CURRENCY_SUCCEED';
export const DOCTOR_CURRENCY_FAILED = 'DOCTOR_CURRENCY_FAILED';

export const DOCTOR_FINISH_INIT_REQUESTED = 'DOCTOR_FINISH_INIT_REQUESTED';
export const DOCTOR_FINISH_INIT_SUCCEED = 'DOCTOR_FINISH_INIT_SUCCEED';
export const DOCTOR_FINISH_INIT_FAILED = 'DOCTOR_FINISH_INIT_FAILED';

export const DOCTOR_UPDATE_PROFESSION_REQUESTED = 'DOCTOR_UPDATE_PROFESSION_REQUESTED';
export const DOCTOR_UPDATE_PROFESSION_SUCCEED = 'DOCTOR_UPDATE_PROFESSION_SUCCEED';
export const DOCTOR_UPDATE_PROFESSION_FAILED = 'DOCTOR_UPDATE_PROFESSION_FAILED';

export const DOCTOR_ADD_PROFESSION_REQUESTED = 'DOCTOR_ADD_PROFESSION_REQUESTED';
export const DOCTOR_ADD_PROFESSION_SUCCEED = 'DOCTOR_ADD_PROFESSION_SUCCEED';
export const DOCTOR_ADD_PROFESSION_FAILED = 'DOCTOR_ADD_PROFESSION_FAILED';

export const DOCTOR_GET_PAYOUT_REQUESTED = 'DOCTOR_GET_PAYOUT_REQUESTED';
export const DOCTOR_GET_PAYOUT_SUCCEED = 'DOCTOR_GET_PAYOUT_SUCCEED';
export const DOCTOR_GET_PAYOUT_FAILED = 'DOCTOR_GET_PAYOUT_FAILED';

export const GET_SPECIALIST_REQUESTED = 'GET_SPECIALIST_REQUESTED';
export const GET_SPECIALIST_SUCCEED = 'GET_SPECIALIST_SUCCEED';
export const GET_SPECIALIST_FAILED = 'GET_SPECIALIST_FAILED';

export const GET_SPECIALITY_REQUESTED = 'GET_SPECIALITY_REQUESTED';
export const GET_SPECIALITY_SUCCEED = 'GET_SPECIALITY_SUCCEED';
export const GET_SPECIALITY_FAILED = 'GET_SPECIALITY_FAILED';

export const DOCTOR_DELETE_PROFESSION_REQUESTED = 'DOCTOR_DELETE_PROFESSION_REQUESTED';
export const DOCTOR_DELETE_PROFESSION_SUCCEED = 'DOCTOR_DELETE_PROFESSION_SUCCEED';
export const DOCTOR_DELETE_PROFESSION_FAILED = 'DOCTOR_DELETE_PROFESSION_FAILED';
export const DOCTOR_SIGNATURE_SUCCEED = 'DOCTOR_SIGNATURE_SUCCEED';

export const GET_WORK_EXPERIENCES_REQUESTED = 'GET_WORK_EXPERIENCES_REQUESTED';
export const GET_WORK_EXPERIENCES_SUCCEED = 'GET_WORK_EXPERIENCES_SUCCEED';
export const GET_WORK_EXPERIENCES_FAILED = 'GET_WORK_EXPERIENCES_FAILED';

export const CREATE_WORK_EXPERIENCE_REQUESTED = 'CREATE_WORK_EXPERIENCE_REQUESTED';
export const CREATE_WORK_EXPERIENCE_SUCCEED = 'CREATE_WORK_EXPERIENCE_SUCCEED';
export const CREATE_WORK_EXPERIENCE_FAILED = 'CREATE_WORK_EXPERIENCE_FAILED';

export const UPDATE_WORK_EXPERIENCE_REQUESTED = 'UPDATE_WORK_EXPERIENCE_REQUESTED';
export const UPDATE_WORK_EXPERIENCE_SUCCEED = 'UPDATE_WORK_EXPERIENCE_SUCCEED';
export const UPDATE_WORK_EXPERIENCE_FAILED = 'UPDATE_WORK_EXPERIENCE_FAILED';

export const DELETE_WORK_EXPERIENCE_REQUESTED = 'DELETE_WORK_EXPERIENCE_REQUESTED';
export const DELETE_WORK_EXPERIENCE_SUCCEED = 'DELETE_WORK_EXPERIENCE_SUCCEED';
export const DELETE_WORK_EXPERIENCE_FAILED = 'DELETE_WORK_EXPERIENCE_FAILED';

export const DOCTOR_UPDATE_PROFESSIONS_REQUESTED = 'DOCTOR_UPDATE_PROFESSIONS_REQUESTED';
export const DOCTOR_UPDATE_PROFESSIONS_SUCCEED = 'DOCTOR_UPDATE_PROFESSIONS_SUCCEED';
export const DOCTOR_UPDATE_PROFESSIONS_FAILED = 'DOCTOR_UPDATE_PROFESSIONS_FAILED';
export const DOCTOR_UPDATE_PROFESSIONS_RESET = 'DOCTOR_UPDATE_PROFESSIONS_RESET';

export const DOCTORS_GET_RECENT_REQUESTED = 'DOCTORS_GET_RECENT_REQUESTED';
export const DOCTORS_GET_RECENT_SUCCEED = 'DOCTORS_GET_RECENT_SUCCEED';
export const DOCTORS_GET_RECENT_FAILED = 'DOCTORS_GET_RECENT_FAILED';

export const DOCTORS_RESET_ERRORS = 'DOCTORS_RESET_ERRORS';
